import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { CarPage } from '@features/cars/components/CarPage'
import { carQueryOptions } from '@features/cars/queries'
import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/cars/staff/$carId')({
    beforeLoad: () => {
        if (!hasPermission('cars.read')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
    loader: async ({ params, context }) => {
        return context.queryClient.ensureQueryData(
            carQueryOptions(params.carId, 'staff'),
        )
    },
    staticData: {
        crumb: {
            dynamicLabel: (match) => match.loaderData?.reg ?? 'Staff Car',
        },
    },
})

function RouteComponent() {
    const { carId } = Route.useParams()

    return (
        <QueryErrorBoundary title="Failed to load car">
            <Suspense fallback={<LoadingIndicator resource='car' />}>
                <CarPage carId={carId} ownerType='staff' />
            </Suspense>
        </QueryErrorBoundary>
    )
}
